module.exports = __webpack_public_path__ + "img/logo.892bb780.svg";